import dynamic from "next/dynamic";
import {getPageInfo, getIndividualPageData, fetchAPIRequestData} from '@/api/global';
import ReactPlaceholder from "react-placeholder";
import GiftCardAuthorizeNetForm
  from "@/components/01_atoms/form/GiftCardAuthorizeNet";
const DefaultNodeComponent = dynamic(() => import('@/components/04_templates/DefaultNode'));

export async function getStaticProps(context) {
  const {params} = context;
  let initialProps = {
    statusCode: 200,
  };

  let data = null, termsMenu = null, recentNodes = null;
  const page = Array.isArray(params?.page) ? params.page.join('/') : params?.page;

  try {
    data = await getPageInfo(`/golf/pro-shop/gift-certificates`);
    if (data && data.page && data.page.entity) {
      let node_data = null;
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
      if (node_data) {
        initialProps = {...initialProps, ...node_data};
      }
    }

    if (!data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('GIFT CERTS Internal retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  return {
    props: {
      ...initialProps,
      // termsMenu: (termsMenu?.page_data || []),
      recentNodes: (recentNodes?.page_data || [])
    }, // will be passed to the page component as props
    revalidate: 3600,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  }
  // return initialProps;
}

function GiftCertificates(props) {
  const node = props.page?.entity || null;
  let node_data = null;

  if (props.page_data) {
    node_data = props.page_data;
  }

  return (
    <ReactPlaceholder type='text' rows={40} ready={node_data?.internalId} showLoadingAnimation={true}>
      {node_data?.id &&
      <div className={`node node-type-${props?.page?.entity?.bundle} node-${props?.page?.entity?.id}`}>
          <DefaultNodeComponent node={node_data}>
            <GiftCardAuthorizeNetForm />
          </DefaultNodeComponent>
      </div>
      }
      {(!node || !node_data) && props?.page?.label &&
      <>
        <h1>{props.page.label}</h1>
        <p>Hmmm... Looks like something is missing here. We will update it
          soon.</p>
      </>
      }
    </ReactPlaceholder>
  );
}

export default GiftCertificates;
